import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import SelectableUserGrid from './SelectableUserGrid';
import SelectableCompanyStack from '../SelectableCompanyStack';

const UserShuttle = ({ 
  assignedUsers, 
  unassignedUsers, 
  onUsersChange,
  onCompanyLevelSelect,  
  selectedCompanyLevel   
}) => {
  const [selectedUnassigned, setSelectedUnassigned] = useState([]);
  const [selectedAssigned, setSelectedAssigned] = useState([]);

  const handleSelectionChangeUnassigned = (newSelection) => {
    setSelectedUnassigned(newSelection);
  };

  const handleSelectionChangeAssigned = (newSelection) => {
    setSelectedAssigned(newSelection);
  };

  const handleAssign = () => {
    const newAssigned = assignedUsers.concat(
      unassignedUsers.filter((metric) => selectedUnassigned.includes(metric.id))
    );
    const newUnassigned = unassignedUsers.filter(
      (metric) => !selectedUnassigned.includes(metric.id)
    );

    setSelectedUnassigned([]);
    onUsersChange(newAssigned, newUnassigned);
  };

  const handleUnassign = () => {
    const newUnassigned = unassignedUsers.concat(
        assignedUsers.filter((metric) => selectedAssigned.includes(metric.id))
    );
    const newAssigned = assignedUsers.filter(
      (metric) => !selectedAssigned.includes(metric.id)
    );

    setSelectedAssigned([]);
    onUsersChange(newAssigned, newUnassigned);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Users
      </Typography>
      <Box display="flex" justifyContent="space-between">
        <Box width="33%">
          <Typography variant="h6">Unassigned</Typography>
          <SelectableUserGrid
            users={unassignedUsers}
            onSelectionChange={handleSelectionChangeUnassigned}
            selectedMetrics={selectedUnassigned}
          />
          <Button
            variant="contained"
            onClick={handleAssign}
            disabled={selectedUnassigned.length === 0}
            sx={{ mt: 2 }}
          >
            Add Metric &gt;
          </Button>
        </Box>
        <Box width="33%">
          <Typography variant="h6">Assigned</Typography>
          <SelectableUserGrid
            data={assignedUsers}
            onSelectionChange={handleSelectionChangeAssigned}
            selectedMetrics={selectedAssigned}
          />
          <Button
            variant="contained"
            onClick={handleUnassign}
            disabled={selectedAssigned.length === 0}
            sx={{ mt: 2 }}
          >
            &lt; Remove Metric
          </Button>
        </Box>
        <Box width="33%">
          <Typography variant="h6">Filter by Company Level</Typography>
          <SelectableCompanyStack 
            onItemSelect={onCompanyLevelSelect}
            selectedItem={selectedCompanyLevel}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default UserShuttle;